@let incidentStatus = status();

<app-pan-chip [width]="175" fill="outline" [color]="incidentStatus === 'has-incident' ? 'danger' : 'success'">
  <div class="flex items-center w-full gap-2">
    <app-pan-incident-status [status]="status()"></app-pan-incident-status>

    {{ count() }} Incidents Found
  </div>
</app-pan-chip>
